/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateServiceAccount {
    getFixupPrototypeFunction() { return TemplateServiceAccount.fixupPrototype; }

    static newInstance(model: Partial<TemplateServiceAccount>): TemplateServiceAccount {
        let obj = Object.assign(new TemplateServiceAccount(), model);
        TemplateServiceAccount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateServiceAccount>): TemplateServiceAccount {
        if (!model) return null;
        return TemplateServiceAccount.newInstance(<TemplateServiceAccount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateServiceAccount) {
        if (!obj) return;

        models.TemplateServiceAccount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateServiceAccount): boolean {
        Object.setPrototypeOf(obj, TemplateServiceAccount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Cloud or integrated tool this account belongs to, for example AWS, Azure, GCP, ServiceNow
     */
    cloud: models.ProviderName;

    /**
     * Cloud/service account ID to run against
     */
    service_account_id: string;

    /**
     * Region to run in. Mandatory for AWS
     */
    region: string;

    /**
     * Zone to run in. Mandatory for GCP
     */
    zones: string;

    /**
     * Resource group to run in. Mandatory for Azure
     */
    resourcegroup: string;

    /**
     * Location to run in. Mandatory for Azure
     */
    location: string;

}
